import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 left-6 z-30 bg-white border border-black/10 text-black rounded-full w-11 h-11 flex items-center justify-center hover:bg-black hover:text-white transition"
      data-testid="back-to-top"
      aria-label="Voltar ao topo"
    >
      <ArrowUp className="w-4 h-4" />
    </button>
  );
}
